<template lang="pug">
button.btn.btn-icon.ripple.ripple--centered.text-gray-800.dark_text-gray-200.p-2.text-xl.h-10.items-center(
  @click="toggle"
  aria-label="Toggle dark mode"
  type="button"
)
  Icon(:icon="dark ? 'ph:moon' : 'ph:sun'")
</template>

<script lang="ts">
export default {
  name: 'ToggleDark'
};
</script>

<script setup lang="ts">
import { watchEffect } from 'vue';
import { useToggle } from '@vueuse/core';
import useDark from '../store/useDark';
import { Icon } from '@iconify/vue';

const dark = useDark();
const toggleDarkMode = useToggle(dark);

// wrap to prevent passing click event as truthy argument
const toggle = () => toggleDarkMode();

watchEffect(() => {
  if (dark.value) {
    document.body.classList.add('dark');
  } else {
    document.body.classList.remove('dark');
  }
});

// const darkMode = ref(document.body.classList.contains('dark'));

// const toggleDarkMode = () => {
//   darkMode.value = !darkMode.value;

//   if (darkMode.value) {
//     document.body.classList.add('dark');
//   } else {
//     document.body.classList.remove('dark');
//   }
// };
</script>
